(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["mp-highlights"] && !Shopify.designMode) return;
  try {
    (function () {
  function setup() {
    document.querySelectorAll('.mp-highlights__more').forEach(function (btn) {
      if (btn.dataset.mpReady) return;
      btn.dataset.mpReady = '1';
      btn.addEventListener('click', function () {
        var wrap = btn.closest('.mp-highlights-wrap');
        var open = wrap.classList.toggle('is-expanded');
        btn.textContent = open ? 'Voir moins' : 'Voir plus';
        btn.setAttribute('aria-expanded', open);
      });
    });
    document.querySelectorAll('.mp-short-desc').forEach(function (p) {
      if (p.dataset.mpReady) return;
      p.dataset.mpReady = '1';
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'mp-more-btn';
      btn.textContent = 'Lire la suite';
      btn.setAttribute('aria-expanded', 'false');
      p.insertAdjacentElement('afterend', btn);
      function check() {
        if (p.classList.contains('is-expanded')) return;
        btn.hidden = p.scrollHeight <= p.clientHeight + 2;
      }
      btn.addEventListener('click', function () {
        var open = p.classList.toggle('is-expanded');
        btn.textContent = open ? 'Voir moins' : 'Lire la suite';
        btn.setAttribute('aria-expanded', open);
      });
      check();
      window.addEventListener('resize', check);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
  document.addEventListener('shopify:section:load', setup);
})();
  } catch(e) { console.error(e); }
})();

})();
